import { render, staticRenderFns } from "./Developers.vue?vue&type=template&id=493c7395&scoped=true&"
import script from "./Developers.vue?vue&type=script&lang=js&"
export * from "./Developers.vue?vue&type=script&lang=js&"
import style0 from "./Developers.vue?vue&type=style&index=0&id=493c7395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493c7395",
  null
  
)

export default component.exports